import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import EntranceTypes from './components/EntranceTypes';
import HowToFind from './components/HowToFind';
import AntiLost from './components/AntiLost';
import Features from './components/Features';
import Faq from './components/Faq';
import Notice from './components/Notice';
import RelatedTerms from './components/RelatedTerms';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main className="w-full">
        <Hero />
        <About />
        <EntranceTypes />
        <HowToFind />
        <AntiLost />
        <Features />
        <Faq />
        <Notice />
        <RelatedTerms />
      </main>
      <Footer />
    </div>
  );
}